@if (totalJobCount > 0) {
  <div class="col-12 col-lg-5 col-xl-4 mb-2">
    <gtapp-auto-complete
      [data]="jobDropDownList"
      placeHolder="Search Jobs"
      searchKeyword="company_name"
      [itemTemplate]="jobTemplate"
      [initialValue]="jobSearchString"
      (inputChanged)="onJobLookup($event)"
      (selected)="openJobView($event)"
      (submitted)="clearValues(); jobSearchString = $event; getJobListData()"
    >
    </gtapp-auto-complete>
    <ng-template #jobTemplate let-item>
      <div>
        {{ item?.service_type }}
        @if (item?.job_key) {
          <span>[{{ item?.job_key }}]</span>
        }
      </div>
      <div class="fw-semibold">{{ item?.site_name }}</div>
      @if (item?.sites) {
        <div class="text-secondary small-font">
          {{ item?.sites }}
        </div>
      }
    </ng-template>
  </div>
}

<gtapp-gt-custom-table
  [deskTopTableData]="jobPaginationData[pageNumJobs] || []"
  [desktopTableDetails]="jobDetailsTableView"
  [tableStyle]="tableStyle"
  [otherParams]="otherParamsJobs"
  (sortColumn)="sortColumnJob($event)"
  (searchColumn)="searchColumnJob($event)"
  (rowClick)="openJobView($event)"
  (paginationChange)="onChangePaginationJob($event)"
></gtapp-gt-custom-table>
